<mat-form-field class="select-form" style="width: 100%;">
  <mat-select placeholder="Crop Year" name="cropYear"
    id="cropYear" class="filter-select"
    [(ngModel)]="selectedCropYear" #cropYearDropdown ="ngModel"
    (selectionChange)="emitCropYear()">
    <mat-option *ngFor="let c of this.cropYearList" [value]="c">
      {{c.year}}
    </mat-option>
  </mat-select>
</mat-form-field>

